import { ROLES } from '@/constants/roles';

export const adminUsersDashboard = {
  path: '/admin-users-dashboard',
  name: 'admin-users-dashboard',
  component: () => import('./views/admin-users-dashboard.vue'),
  meta: {
    title: 'Пользователи',
    layout: 'ui-design',
    roles: [ROLES.admin],
  },
};

export const adminEventsDashboard = {
  path: '/admin-events-dashboard',
  name: 'admin-events-dashboard',
  component: () => import('./views/admin-events-dashboard.vue'),
  meta: {
    title: 'Мероприятия',
    layout: 'ui-design',
    roles: [ROLES.admin],
  },
};

export const adminEventsModerate = {
  path: '/admin-events-moderate',
  name: 'admin-events-moderate',
  component: () => import('./views/admin-events-moderate.vue'),
  meta: {
    title: 'Модерация мероприятий',
    layout: 'ui-design',
    roles: [ROLES.admin],
  },
};

export default [
  adminUsersDashboard,
  adminEventsDashboard,
  adminEventsModerate,
];
